<div class="select-container-concepts">
  <div class="select-button" (click)="handleButtonClick($event)">
    <div
      class="button-text"
      [ngClass]="{ placeholder: !isOptionSelected, selected: isOptionSelected }"
      [matTooltip]="isOptionSelected ? selectedText : ''"
      [matTooltipDisabled]="!isOptionSelected || selectedText.length <= 18"
      matTooltipPosition="above"
    >
      {{ truncatedText }}
    </div>
    <div class="button-icon">
      <img src="assets/icons/keyboard_arrow_different.svg" alt="" />
    </div>
  </div>

  <div
    class="dropdown-content-container-concepts"
    *ngIf="dropdownOpened"
    appOutSideClick
    (outSideClick)="onOutsideClick()"
  >
    <div class="container-header-concepts">
      <div class="header-title">Saved concepts</div>
    </div>

    <div class="option-search-container">
      <input
        type="text"
        [(ngModel)]="searchQuery"
        placeholder="Search"
        (click)="stopPropagation($event)"
        class="custom-input"
      />
      <span class="close-icon" *ngIf="searchQuery" (click)="clearSearch(); $event.stopPropagation()">
        <img src="assets/icons/close.svg" alt="Clear" />
      </span>
    </div>

    <div class="columns-list" *ngIf="!loading; else loadingTpl">
      <div
        class="column-item"
        *ngFor="let item of getFilteredConcepts()"
        (click)="handleOptionSelect($event, item)"
      >
        <div class="column-main">
          <div class="column-name">{{ item.name }}</div>
          <div class="column-meta">
            <span class="badge" [class.global]="item.isGlobal" [class.private]="!item.isGlobal">
              {{ visibilityLabel(item) }}
            </span>
            <span class="creator" *ngIf="item.createdByEmail || item.createdBy">
              {{ item.createdByEmail || item.createdBy }}
            </span>
          </div>
        </div>
        <button
          type="button"
          class="delete-btn"
          title="Delete"
          (click)="handleDelete($event, item)"
        >
          <img src="assets/icons/close.svg" alt="Delete" />
        </button>
      </div>

      <div class="empty-state" *ngIf="!getFilteredConcepts().length">
        No saved concepts
      </div>
    </div>

    <ng-template #loadingTpl>
      <div class="empty-state">Loading…</div>
    </ng-template>
  </div>
</div>
